/* glightbox
========================================================= */
export function glightbox() {
  if (typeof GLightbox === 'undefined') {
    return;
  }

  const links = document.querySelectorAll(
    ':is(.page-content, .entry-content) a:is([href$=".jpg" i], [href$=".jpeg" i], [href$=".png" i], [href$=".webp" i], [href$=".svg" i])'
  );

  if (!links.length) {
    return;
  }

  links.forEach((link) => {
    link.classList.add('glightbox');
  });

  GLightbox({
    selector: '.glightbox',
  });
}
